import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const tableBaseSx: SystemStyleObject<Theme> = {
  '& tbody td': {
    verticalAlign: 'middle',
  },
  '& tbody tr:hover': {
    backgroundColor: 'transparent',
    '@media (min-width: 992px)': {
      backgroundColor: 'background.default',
    },
  },
};

export const listGeneralSharedSx: SystemStyleObject<Theme> = {
  '& .th-buttons': {
    width: '100px',
  },
  '& .list-btn-container': {
    textAlign: 'right',
    pr: '8px',
    pl: '8px',
    '& .MuiButtonBase-root': {
      width: '100%',
      fontSize: '14px',
    },
  },
  '& th': {
    whiteSpace: 'nowrap',
    width: '100px',
  },
  '& th + th': {
    width: 'auto',
  },
};

export const listGeneralTableSx: SystemStyleObject<Theme> = {
  tableLayout: 'fixed',
  ...listGeneralSharedSx,
};
